export default __webpack_public_path__ + "static/logo-f9a14c92e126da5df721c37e7c4baa9d.png";